import { API_URL } from '../../../config';
import axiosInstance from '../../../util/axiosAPI';

class AntennaService {
    
    constructor() { }

    getAll() {
        const url = `${API_URL}/api/gnss/antennas/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    get(id) {
        const url = `${API_URL}/api/gnss/antennas/${id}/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    create(data) {
        const url = `${API_URL}/api/gnss/antennas/`;
        return axiosInstance.post(url, data).then(response => response.data);
    }

    update(id, data) {
        const url = `${API_URL}/api/gnss/antennas/${id}/`;
        return axiosInstance.put(url, data).then(response => response.data);
    }

    delete(id) {
        const url = `${API_URL}/api/gnss/antennas/${id}/`;
        return axiosInstance.delete(url).then(response => response.data);
    }
}

export default AntennaService;
